import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import {switchLocale} from '../actions/appConfig'; 
const $ = window.$;

class Header extends Component {

  constructor(props){
    super(props);

    let search = props.history.location.search.split("?q=");
    search = search.length ? search[1]: '';
    this.state = {search,}
  }

  componentDidMount(){
    if (this.textInput){
      this.textInput && this.textInput.focus();
      var temp_value = this.textInput.value;
      this.textInput.value = '';
      this.textInput.value = temp_value;
    }
    $('.mid-header').sticky({ topSpacing: 0 });
  }

  isActivePathname(pathname){
    return this.props.location && this.props.location.pathname === pathname;
  }

  getMenuItemClass(pathname){
    let className= this.isActivePathname(pathname) ? 'active':'';
    return className
  }

  onChange = (e) =>{
    let search = e.target.value ;

    this.setState({
       [e.target.name]: search
     });
    this.doSearch(search);
  }

  search = (e) =>{
    let search = this.state.search;
    this.doSearch(search);
  }

  doSearch (search){
    if (!this.props.onSearchBarTextChanged){

      this.props.history && this.props.history.replace && this.props.history.push({
        pathname: this.props.location.pathname,
        search: '?q=' + search,
      });
    }else{
      this.props.onSearchBarTextChanged && this.props.onSearchBarTextChanged(search);
    }
  }

  renderSwitchLocale (){
    const {locale} = this.props;
    const locales = [
      {code:'fr', imageSource:"images/flags/flag_french.png"},
      {code:'en', imageSource:"images/flags/flag_english.png"},
      // {code:'es', imageSource:"images/flags/flag_spain.png"},
    ];

    return (
      <div className="switcher  switcher-language">
          <strong className="title">Select language</strong>
          <ul className="switcher-options ">
               {
                 locales.map((localeItem,i) => {
                   return (
                     <li key={localeItem.code} className={"switcher-option" + (locale === localeItem.code ? ' switcher-active':'')}>
                         <a onClick={() => this.props.switchLocale(localeItem.code)}>
                             <img className="switcher-flag" alt="flag" src={localeItem.imageSource}/>
                         </a>
                     </li>
                   )
                 })
               }
          </ul>
      </div>

    )
  }
 
  render() {
    
    let  kioskLogo  = process.env.REACT_APP_KIOSK_LOGO ||  'images/digital-kiosk.png';
    return (
       <header className="site-header header-opt-2">
          <div className="header-top"> 
          </div>
          <div className="header-content">
              <div className="container">
                  <div className="row">

                      <div className="col-md-12 nav-center text-center">
                          <strong className="logo">
                              <Link to="/publications"><img src={kioskLogo} alt="logo"/></Link>
                          </strong>
                      </div>

                  
                  </div>
              </div>
          </div> 
      </header>
    );
  }
}

function bindAction(dispatch) {
    return {
      switchLocale: locale => dispatch(switchLocale(locale)),
    };
}

const mapStateToProps = state => ({
  isAuth: !!state.security.user,
  locale: state.appConfig.locale,
});

export default connect(mapStateToProps, bindAction)(Header);



// WEBPACK FOOTER //
// ./src/common/Header.js